import { Box } from '@mui/material'
import { DetailsTable } from 'Features/Projects/Scenarios/Templates/TemplateResults/Details/Details.table'
import { TemplateOutputs } from 'Features/Projects/Scenarios/Templates/TemplateResults/TemplateResults.types'

type DetailsViewProps = {
  data: TemplateOutputs[]
  isLoading: boolean
  width: number
  height: number
}

export const DetailsView = ({
  data,
  isLoading,
  width,
  height,
}: DetailsViewProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      sx={{
        flex: 1,
        overflow: 'auto',
        paddingTop: 3,
      }}
      width={width}
      maxHeight={height - 100}
    >
      <DetailsTable data={data} isLoading={isLoading} />
    </Box>
  )
}
